import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAuth} from '../../../../../app/modules/auth'
import {isLangEN} from '_metronic/helpers/GeneralHelper'
import {encryptId} from '_metronic/helpers/Encrypt'
import {useAppSelector} from '../../../../../redux/hooks'

export function DphsMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const base = '/dphs/'
  const {msgCount} = useAppSelector((state) => state.chat)
  const menuPlacement = isLangEN() ? 'bottom-start' : 'bottom-end'
  const subMenuPlacement = isLangEN() ? 'right-start' : 'left-start'

  return (
    <>
      {/* CLASS ROOM */}
      {hasPermission('class-room-list') && (
        <MenuInnerWithSub
          title={t('MENU.CLASS_ROOM')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          <MenuItem
            to={`${base}class-rooms`}
            fontIcon='fas fa-chalkboard'
            title={t('MENU.CLASS_ROOMS')}
          />
        </MenuInnerWithSub>
      )}

      {/* STUDENTS */}
      {(hasPermission('school-student-list') ||
        hasPermission('school-student-attendance-report') ||
        hasPermission('school-student-assessment-score-report') ||
        hasPermission('school-student-score-report') ||
        hasPermission('school-student-subject-grade-sheet') ||
        hasPermission('school-student-class-upgrade')) && (
        <MenuInnerWithSub
          title={t('SCHOOL.STUDENTS')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('school-student-list') && (
            <MenuItem
              to={`${base}students`}
              fontIcon='fas fa-user-graduate'
              title={t('SCHOOL.STUDENTS')}
            />
          )}

          {hasPermission('school-student-archive-list') && (
            <MenuItem
              to={`/dphs/students/${encryptId('Archive')}`}
              fontIcon='fas fa-archive mx-2'
              title={t('SCHOOL.ARCHIVE_STUDENTS')}
            />
          )}

          {hasPermission('school-student-transfer-list') && (
            <MenuItem
              to={`/dphs/students/${encryptId('Transfer')}`}
              fontIcon='fas fa-exchange mx-2'
              title={t('SCHOOL.TRANSFER_STUDENTS')}
            />
          )}

          {hasPermission('school-student-alumni-list') && (
            <MenuItem
              to={`/dphs/students/${encryptId('Alumni')}`}
              fontIcon='fas fa-graduation-cap mx-2'
              title={t('SCHOOL.ALUMNI_STUDENTS')}
            />
          )}

          {(hasPermission('school-student-promotion') ||
            hasPermission('school-student-promotion-report') ||
            hasPermission('school-student-promotion-class-upgrade')) && (
            <MenuInnerWithSub
              title={t('SCHOOL.STUDENT_PROMOTION')}
              to={''}
              fontIcon='fas fa-chalkboard-teacher mx-2'
              hasArrow={true}
              menuPlacement={subMenuPlacement}
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('school-student-promotion') && (
                <MenuItem
                  to='/dphs/student-promotion'
                  fontIcon='fas fa-pager mx-2'
                  title={t('SCHOOL.STUDENT_PROMOTION')}
                />
              )}

              {hasPermission('school-student-promotion-report') && (
                <MenuItem
                  to='/dphs/student-promotion-report'
                  fontIcon='fas fa-user-check mx-2'
                  title={t('MENU.REPORT')}
                />
              )}

              {hasPermission('school-student-promotion-class-upgrade') && (
                <MenuItem
                  to='/dphs/student-promotion-class-upgrade'
                  fontIcon='fas fa-list-check mx-2'
                  title={t('MENU.CLASS_UPGRADE')}
                />
              )}
            </MenuInnerWithSub>
          )}

          {hasPermission('school-student-fail-list') && (
            <MenuItem
              to='/dphs/fail-students'
              fontIcon='fas fa-user-slash mx-2'
              title={t('SCHOOL.FAIL_STUDENTS')}
            />
          )}

          {hasPermission('school-student-result-paper') && (
            <MenuItem
              to='/dphs/student-result-paper'
              fontIcon='fas fa-book-open mx-2'
              title={t('SCHOOL.STUDENT_RESULT_PAPER')}
            />
          )}

          {hasPermission('school-student-mark-alumni') && (
            <MenuItem
              to='/dphs/mark-student-as-alumni'
              fontIcon='fas fa-address-book mx-2'
              title={t('SCHOOL.MARK_STUDENT_ALUMNI')}
            />
          )}

          <MenuInnerWithSub
            title={t('MENU.REPORT')}
            to={''}
            fontIcon='fas fa-list-check mx-2'
            hasArrow={true}
            menuPlacement={subMenuPlacement}
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {hasPermission('school-student-attendance-report') && (
              <MenuItem
                to='/dphs/student-attendance-report'
                fontIcon='fas fa-calendar-check mx-2'
                title={t('MENU.ATTENDANCE_REPORT')}
              />
            )}

            {hasPermission('school-student-assessment-score-report') && (
              <MenuItem
                to='/dphs/student-assessment-score-report'
                fontIcon='fa fa-clipboard-list mx-2'
                title={t('SCHOOL.ASSESSMENT_SCORE_REPORT')}
              />
            )}

            {hasPermission('school-student-score-report') && (
              <MenuItem
                to='/dphs/student-score-report'
                fontIcon='fa fa-clipboard-list mx-2'
                title={t('MENU.SCORE_REPORT')}
              />
            )}

            {hasPermission('school-student-subject-grade-sheet') && (
              <MenuItem
                to='/dphs/student-subject-grade-sheet'
                fontIcon='fas fa-list-check mx-2'
                title={t('SCHOOL.SUBJECT_GRADE_SHEET')}
              />
            )}

            {hasPermission('school-student-class-upgrade') && (
              <MenuItem
                to='/dphs/student-class-upgrade'
                fontIcon='fas fa-list-check mx-2'
                title={t('MENU.CLASS_UPGRADE')}
              />
            )}
          </MenuInnerWithSub>
        </MenuInnerWithSub>
      )}

      {/* HR */}
      {(hasPermission('school-position-list') ||
        hasPermission('school-employee-list') ||
        hasPermission('school-organization-unit-list')) && (
        <MenuInnerWithSub
          title={t('MENU.HR')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
          fontIcon=''
        >
          {hasPermission('school-employee-list') && (
            <MenuInnerWithSub
              title={t('MENU.EMPLOYEE')}
              to='/dua/employees'
              fontIcon='fas fa-user-tie mx-2'
              hasArrow={true}
              menuPlacement={subMenuPlacement}
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('school-employee-list') && (
                <MenuItem
                  to='dphs/school-employees'
                  fontIcon='fas fa-user-tie mx-2'
                  title={t('MENU.EMPLOYEE')}
                />
              )}
              {hasPermission('school-employee-attendance-create') && (
                <MenuItem
                  to='dphs/school-employee-attendance-create'
                  fontIcon='fas fa-calendar-check mx-2'
                  title={t('MENU.ATTENDANCE')}
                />
              )}
              {hasPermission('school-employee-attendance-view') && (
                <MenuItem
                  to='dphs/school-employee-attendance-view'
                  fontIcon='fas fa-calendar mx-2'
                  title={t('MENU.ATTENDANCE_VIEW')}
                />
              )}
              {hasPermission('school-employee-leave-list') && (
                <MenuItem
                  to='dphs/school-employee-leaves'
                  fontIcon='fas fa-calendar-day mx-2'
                  title={t('MENU.LEAVE')}
                />
              )}
              {hasPermission('school-employee-attendance-report') && (
                <MenuItem
                  to='dphs/school-employee-attendance-report'
                  fontIcon='fas fa-file-alt mx-2'
                  title={t('MENU.ATTENDANCE_REPORT')}
                />
              )}
              {hasPermission('school-employee-attendance-payroll') && (
                <MenuItem
                  to='dphs/school-employee-attendance-payroll'
                  fontIcon='fas fa-file-invoice-dollar mx-2'
                  title={t('MENU.ATTENDANCE_PAYROLL')}
                />
              )}
            </MenuInnerWithSub>
          )}

          {hasPermission('school-organization-unit-list') && (
            <MenuItem
              to='dphs/school-organization-list'
              fontIcon='fas fa-sitemap mx-2'
              title={t('MENU.ORGANIZATION_UNITS')}
            />
          )}

          {hasPermission('school-position-list') && (
            <MenuItem
              to='/dphs/school-positions'
              fontIcon='fas fa-clipboard-list mx-2'
              title={t('MENU.POSITION')}
            />
          )}
          {hasPermission('school-item-distribution-list') && (
            <MenuItem
              to='/dphs/school-item-distribution-list'
              fontIcon='fas fa-dolly mx-2'
              title={t('MENU.ITEM_DISTRIBUTION')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* FINANCE */}
      {(hasPermission('school-finance-categories-list') ||
        hasPermission('school-finance-companies-list') ||
        hasPermission('school-student-fee-list') ||
        hasPermission('school-finance-items-list') ||
        hasPermission('school-finance-items-stock-list') ||
        hasPermission('school-finance-purchase-list') ||
        hasPermission('school-student-book-list') ||
        hasPermission('student-transport-payments-list') ||
        hasPermission('school-student-uniform-list')) && (
        <MenuInnerWithSub
          title={t('MENU.FINANCE')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          <MenuInnerWithSub
            title={t('SCHOOL.STUDENTS')}
            to=''
            fontIcon='fas fa-user-graduate mx-2'
            hasArrow={true}
            menuPlacement={subMenuPlacement}
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {hasPermission('school-student-fee-list') && (
              <MenuItem
                to={`${base}school-student-fees-list`}
                fontIcon='fas fa-usd mx-2'
                title={t('SCHOOL.STUDENTS_FEE')}
              />
            )}

            {hasPermission('school-student-book-list') && (
              <MenuItem
                to={`${base}school-student-book-list`}
                fontIcon='fas fa-book mx-2'
                title={t('SCHOOL.STUDENT_BOOK_FEE')}
              />
            )}
            {hasPermission('school-student-uniform-list') && (
              <MenuItem
                to={`${base}school-student-uniform-list`}
                fontIcon='fas fa-tshirt mx-2'
                title={t('SCHOOL.STUDENT_UNIFORM_FEE')}
              />
            )}
            {hasPermission('student-transport-payments-list') && (
              <MenuItem
                to={`${base}school-transport-payment-list`}
                fontIcon='fas fa-bus mx-2'
                title={t('MENU.TRANSPORT_PAYMENT')}
              />
            )}
          </MenuInnerWithSub>

          {hasPermission('school-finance-categories-list') && (
            <MenuItem
              to={`${base}school-finance-category-list`}
              fontIcon='fas fa-wallet mx-2'
              title={t('MENU.FINANCE_CATEGORIES')}
            />
          )}

          {hasPermission('school-finance-categories-list') && (
            <MenuItem
              to={`${base}school-finance-sub-category-list`}
              fontIcon='fas fa-list-ul mx-2'
              title={t('MENU.FINANCE_SUB_CATEGORIES')}
            />
          )}

          {hasPermission('school-finance-companies-list') && (
            <MenuItem
              to={`${base}school-finance-company-list`}
              fontIcon='fas fa-building mx-2'
              title={t('MENU.COMPANIES')}
            />
          )}

          <MenuInnerWithSub
            title={t('MENU.CANTEEN_ITEM')}
            to=''
            fontIcon='fas fa-dolly mx-2'
            hasArrow={true}
            menuPlacement={subMenuPlacement}
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {hasPermission('school-finance-items-list') && (
              <MenuItem
                to={`${base}school-finance-items`}
                fontIcon='fas fa-dolly mx-2'
                title={t('MENU.CANTEEN_ITEM')}
              />
            )}
            {hasPermission('school-finance-items-stock-list') && (
              <MenuItem
                to={`${base}school-finance-stock`}
                fontIcon='fas fa-warehouse mx-2'
                title={t('MENU.CANTEEN_ITEM_STOCK')}
              />
            )}
            {hasPermission('school-finance-purchase-list') && (
              <MenuItem
                to={`${base}school-finance-purchase-list`}
                fontIcon='fas fa-file-invoice mx-2'
                title={t('MENU.PURCHASE')}
              />
            )}
            {hasPermission('school-item-depreciation-list') && (
              <MenuItem
                to={`${base}school-item-depreciation`}
                fontIcon='fas fa-exclamation-triangle mx-2'
                title={t('MENU.ITEM_DEPRECIATION')}
              />
            )}
            {hasPermission('school-item-depreciation-report') && (
              <MenuItem
                to={`${base}school-item-depreciation-report`}
                fontIcon='fas fa-file-alt mx-2'
                title={t('MENU.ITEM_DEPRECIATION_REPORT')}
              />
            )}
          </MenuInnerWithSub>

          <MenuInnerWithSub
            title={t('MENU.BOOK')}
            to=''
            fontIcon='fas fa-book mx-2'
            hasArrow={true}
            menuPlacement={subMenuPlacement}
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {hasPermission('school-book-stock-list') && (
              <MenuItem
                to={`${base}school-book-stock`}
                fontIcon='fas fa-book mx-2'
                title={t('MENU.BOOK_STOCK')}
              />
            )}
            {hasPermission('school-book-purchase-list') && (
              <MenuItem
                to={`${base}school-book-purchase-list`}
                fontIcon='fas fa-file-invoice mx-2'
                title={t('MENU.BOOK_PURCHASE')}
              />
            )}
            {hasPermission('school-book-depreciation-list') && (
              <MenuItem
                to={`${base}school-book-depreciation`}
                fontIcon='fas fa-exclamation-triangle mx-2'
                title={t('MENU.BOOK_DEPRECIATION')}
              />
            )}
            {hasPermission('school-book-depreciation-report') && (
              <MenuItem
                to={`${base}school-book-depreciation-report`}
                fontIcon='fas fa-file-alt mx-2'
                title={t('MENU.BOOK_DEPRECIATION_REPORT')}
              />
            )}
          </MenuInnerWithSub>

          <MenuInnerWithSub
            title={t('MENU.UNIFORM')}
            to=''
            fontIcon='fas fa-tshirt mx-2'
            hasArrow={true}
            menuPlacement={subMenuPlacement}
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            {hasPermission('school-uniform-stock-list') && (
              <MenuItem
                to={`${base}school-uniform-stock`}
                fontIcon='fas fa-tshirt mx-2'
                title={t('MENU.UNIFORM_STOCK')}
              />
            )}
            {hasPermission('school-uniform-purchase-list') && (
              <MenuItem
                to={`${base}school-uniform-purchase-list`}
                fontIcon='fas fa-file-invoice mx-2'
                title={t('MENU.UNIFORM_PURCHASE')}
              />
            )}
            {hasPermission('school-uniform-depreciation-list') && (
              <MenuItem
                to={`${base}school-uniform-depreciation`}
                fontIcon='fas fa-exclamation-triangle mx-2'
                title={t('MENU.UNIFORM_DEPRECIATION')}
              />
            )}
            {hasPermission('school-uniform-depreciation-report') && (
              <MenuItem
                to={`${base}school-uniform-depreciation-report`}
                fontIcon='fas fa-file-alt mx-2'
                title={t('MENU.UNIFORM_DEPRECIATION_REPORT')}
              />
            )}
          </MenuInnerWithSub>

          {hasPermission('school-finance-payments-list') && (
            <MenuItem
              to={`${base}school-finance-payments`}
              fontIcon='fas fa-hand-holding-usd mx-2'
              title={t('LABEL.PAYMENTS')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* FINANCE */}
      {(hasPermission('school-finance-categories-list') ||
        hasPermission('school-finance-companies-list') ||
        hasPermission('school-student-fee-list') ||
        hasPermission('school-finance-items-list') ||
        hasPermission('school-finance-items-stock-list') ||
        hasPermission('school-finance-purchase-list') ||
        hasPermission('school-student-book-list') ||
        hasPermission('student-transport-payments-list') ||
        hasPermission('school-student-uniform-list')) && (
        <MenuInnerWithSub
          title={t('MENU.REPORT')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={false}
        >
          {hasPermission('school-finance-payments-company-transaction-report') && (
            <MenuItem
              to={`${base}std-fin-rep-opts`}
              fontIcon='fas fa-dollar mx-2'
              title={t('MENU.STUDENT_INVOICE')}
            />
          )}
          {hasPermission('school-finance-payments-ministry-report') && (
            <MenuItem
              to={`${base}school-finance-report`}
              fontIcon='fas fa-file mx-2'
              title={t('MENU.FINANCE_REPORT')}
            />
          )}

          {hasPermission('school-finance-payments-cash-report') && (
            <MenuItem
              to={`${base}school-cash-report`}
              fontIcon='fas fa-usd mx-2'
              title={t('MENU.CASH_REPORT')}
            />
          )}
          {hasPermission('school-finance-payments-daily-expense-report') && (
            <MenuItem
              to={`${base}school-finance-daily-expenses-report`}
              fontIcon='fas fa-file-invoice-dollar mx-2'
              title={t('LABEL.DAILY_EXPENSES')}
            />
          )}
          {hasPermission('school-finance-payments-employee-transaction-report') && (
            <MenuItem
              to={`${base}school-finance-employee-transactions-report`}
              fontIcon='fas fa-file-invoice-dollar mx-2'
              title={t('LABEL.EMPLOYEE_TRANSACTION')}
            />
          )}
          {hasPermission('school-finance-payments-company-transaction-report') && (
            <MenuItem
              to={`${base}school-finance-company-transactions-report`}
              fontIcon='fas fa-file-invoice-dollar mx-2'
              title={t('LABEL.COMPANY_TRANSACTION')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {hasPermission('user-list') && (
        <MenuInnerWithSub
          title={t('MENU.USERS')}
          to=''
          menuPlacement={menuPlacement}
          menuTrigger='click'
          hasArrow={true}
        >
          {hasPermission('user-list') && (
            <MenuItem
              to={`${base}school-staff-users`}
              fontIcon='fa fa-users mx-2'
              title={t('MENU.STAFF_USERS')}
            />
          )}
          {hasPermission('user-list') && (
            <MenuItem
              to={`${base}school-lecturer-users`}
              fontIcon='fa fa-users mx-2'
              title={t('MENU.LECTURER_USERS')}
            />
          )}
          {hasPermission('user-list') && (
            <MenuItem
              to={`${base}school-student-users`}
              fontIcon='fa fa-users mx-2'
              title={t('MENU.STUDENT_USERS')}
            />
          )}
        </MenuInnerWithSub>
      )}
      <MenuItem
        to='/chat/dphs-ad-chat-room'
        title={
          <span className='position-relative'>
            {t('CHAT.CHAT')}
            <span className='badge badge-circle bg-danger position-absolute top-0 text-white translate-middle'>
              {msgCount}
            </span>
          </span>
        }
      />
    </>
  )
}
